import { useState } from "react";
import axios from "axios";

export default function NewWebsiteForm() {
const token = localStorage.getItem("token"); 
  const [form, setForm] = useState({
      naziv: "",
      httpadresa: "",
      ref_num: "",
      sajt_akreditacija: "",
      cpanel_akreditacija: "",
      domen_expire: "",
      hosting_expire: "",
      odrzavanje: "",
      klijentID: "",
  });

  const [msg, setMsg] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(
      `/api/websites`,
      form
    , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setMsg("Sajt dodat uspešno ✅");

      setForm({
        naziv: "",
        httpadresa: "",
        ref_num: "",
        sajt_akreditacija: "",
        cpanel_akreditacija: "",
        domen_expire: "",
        hosting_expire: "",
        odrzavanje: "",
        klijentID: "",
      });
    })
    .catch(err => {
      console.error(err);
      setMsg("Greška pri dodavanju ❌");
    });
  };

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Unesi novi sajt</h4>

      <form onSubmit={handleSubmit}>

        <label for="ime">Naziv</label>
          <input className="form-control mb-2"
            name="naziv"
            value={form.naziv}
            onChange={handleChange}
          />

          <label for="ime">HTTP</label>
          <input className="form-control mb-2"
            name="httpadresa"
            value={form.httpadresa}
            onChange={handleChange}  
          />

          <label for="ref_num">Reference</label>
          <input className="form-control mb-2"
            name="ref_num"
            value={form.ref_num}
            onChange={handleChange}
          />

          <label for="sajt_akreditacija">Sajt Login</label>
          <input className="form-control mb-2"
            name="sajt_akreditacija"
            value={form.sajt_akreditacija}
            onChange={handleChange}
          />

          <label for="ime">CPanel Login</label>
          <input className="form-control mb-2"
            name="cpanel_akreditacija"
            value={form.cpanel_akreditacija}
            onChange={handleChange}
          />

          <label for="ime">domen_expire</label>
          <input className="form-control mb-2"
            name="domen_expire"
            value={form.domen_expire}
            onChange={handleChange}
          />

          <label for="ime">hosting_expire</label>
          <input className="form-control mb-2"
            name="hosting_expire"
            value={form.hosting_expire}
            onChange={handleChange}
          />   

          <label for="ime">odrzavanje</label>
          <input className="form-control mb-2"
            name="odrzavanje"
            value={form.odrzavanje}
            onChange={handleChange}
          />    

          <label for="ime">Klijent - ID</label>
          <input className="form-control mb-2"
            name="klijentID"
            value={form.klijentID}
            onChange={handleChange}
          />   


        <button className="btn btn-primary w-100">
          Dodaj sajt
        </button>

      </form>

      {msg && <p className="mt-3">{msg}</p>}
    </div>
  );
}